var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BackboneContainer',{attrs:{"id":_vm.id,"className":_vm.className,"dispatchReadyOnMount":_vm.dispatchReadyOnMount}})
}
var staticRenderFns = []

export { render, staticRenderFns }